export default {
  step0: {
    title: 'Заполните номер телефона',
    desc: 'Это необходимо для вашей <br>верификации на портале'
  },
  step1: {
    title: 'Введите код из СМС',
    desc: 'Мы отправили его на номер:',
    descRefresh: 'Повторная отправка возможна через:',
    seconds: 'сек.',
    refreshSend: 'Отправить повторно'
  },
  step2: {
    title: 'Успешно',
    desc: 'Спасибо, что прошли верификацию на портале',
  },
  step3: {
    title: 'Упс!',
    desc: 'Вы уже верифицированы',
  },
  back: 'Назад',
  changeNumber: 'Изменить номер',
  sendCode: 'Отправить код',
  error: {
    codeIsAlreadyExpired: 'Срок действия кода истёк',
    codeIsIncorrect: 'Неверный проверочный код',
    alreadyValidated: 'Телефон уже подтвержден',
    unknownError: 'Неизвестная ошибка'
  }
}
